import { FieldLabel, TextInput } from '../../components/Primitives.jsx';

// ── Decimal Places (Optional) ──────────────────────────────────────────
// Shared by every block that computes a numeric result. It is OPTIONAL and
// has no implicit rounding: a blank field means the full, unrounded value
// is kept. `defaultPlaces` exists only for a block that deliberately wants
// a fallback other than full precision — none does today, so every call
// site passes null (or omits the prop). Backend counterpart:
// output_decimals(cfg)/round_result() in server/app/engine/helpers.py —
// the config key is `output_decimals`.
export function DecimalPlacesField({ value, onChange, defaultPlaces = null, label = 'Decimal Places (Optional)' }) {
  const fallback = defaultPlaces == null
    ? 'the full value is kept (no rounding)'
    : `${defaultPlaces} decimal places are used`;
  return (
    <div style={{ marginBottom: 10 }}>
      <FieldLabel hint={`Optional — how many digits to keep after the decimal point in the result. If you leave this blank, ${fallback}, so there is always an output.`}>{label}</FieldLabel>
      <TextInput
        type="number"
        value={value ?? ''}
        onChange={onChange}
        placeholder={defaultPlaces == null ? 'Default: no rounding' : `Default: ${defaultPlaces}`}
      />
    </div>
  );
}
